import React, { useEffect, useState, useCallback } from "react";
import { TableEmpty } from "@finance/components/DesignSystem";
import { api, fmtNum, fmtDate } from "@finance/lib/api";
import Layout, { PageHeader } from "@finance/components/Layout";
import { StatusBadge } from "@finance/components/StatusBadge";
import { Button } from "@finance/components/ui/button";
import { toast } from "sonner";
import { ArrowCounterClockwise } from "@phosphor-icons/react";

export default function DeletedItems() {
  const [data, setData] = useState({ transactions: [], actions: [] });

  const load = useCallback(() => api.get("/deleted-items").then((r) => setData(r.data)), []);
  useEffect(() => { load(); }, [load]);

  const restoreTxn = async (id) => { await api.post(`/transactions/${id}/restore`); toast.success("Transaction restored"); load(); };
  const restoreAction = async (id) => { await api.post(`/actions/${id}/restore`); toast.success("Action restored"); load(); };

  return (
    <Layout>
      <PageHeader title="Deleted Items" subtitle="Soft-deleted records kept for tracing — restore any time" />
      <div className="space-y-8 p-8">
        <div>
          <h3 className="mb-2 font-display text-base font-bold text-gray-900">Transactions ({data.transactions.length})</h3>
          <div className="overflow-hidden rounded-sm border border-gray-200 bg-white">
            <table className="w-full text-sm">
              <thead className="bg-gray-50"><tr className="lx-label border-b border-gray-200">
                <th className="px-4 py-2 text-left">Somcore PO</th><th className="px-4 py-2 text-left">Supplier</th>
                <th className="px-4 py-2 text-left">Status</th><th className="px-4 py-2 text-left">Deleted By</th>
                <th className="px-4 py-2 text-left">Deleted At</th><th className="px-4 py-2 text-right">Action</th>
              </tr></thead>
              <tbody>
                {data.transactions.length === 0 && <TableEmpty colSpan={6} title="No deleted transactions" message="Soft-deleted Somcore POs will appear here for restore." />}
                {data.transactions.map((t) => (
                  <tr key={t.id} data-testid={`deleted-txn-${t.id}`} className="border-b border-gray-100">
                    <td className="px-4 py-2 font-mono-num">{t.lx_po_no || "—"}</td>
                    <td className="px-4 py-2">{t.supplier_name || "—"}</td>
                    <td className="px-4 py-2"><StatusBadge status={t.status} /></td>
                    <td className="px-4 py-2">{t.deleted_by || "—"}</td>
                    <td className="px-4 py-2 lx-num">{fmtDate(t.deleted_at)}</td>
                    <td className="px-4 py-2 text-right">
                      <Button size="sm" variant="outline" data-testid={`restore-txn-${t.id}`} onClick={() => restoreTxn(t.id)}><ArrowCounterClockwise size={14} className="mr-1" />Restore</Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div>
          <h3 className="mb-2 font-display text-base font-bold text-gray-900">Actions ({data.actions.length})</h3>
          <div className="overflow-hidden rounded-sm border border-gray-200 bg-white">
            <table className="w-full text-sm">
              <thead className="bg-gray-50"><tr className="lx-label border-b border-gray-200">
                <th className="px-4 py-2 text-left">Details</th><th className="px-4 py-2 text-left">Assignee</th>
                <th className="px-4 py-2 text-left">Deleted By</th><th className="px-4 py-2 text-left">Deleted At</th>
                <th className="px-4 py-2 text-right">Action</th>
              </tr></thead>
              <tbody>
                {data.actions.length === 0 && <TableEmpty colSpan={5} title="No deleted actions" message="Soft-deleted actions will appear here for restore." />}
                {data.actions.map((a) => (
                  <tr key={a.id} data-testid={`deleted-action-${a.id}`} className="border-b border-gray-100">
                    <td className="px-4 py-2">{a.details}</td>
                    <td className="px-4 py-2">{a.assigned_to_name || "—"}</td>
                    <td className="px-4 py-2">{a.deleted_by || "—"}</td>
                    <td className="px-4 py-2 lx-num">{fmtDate(a.deleted_at)}</td>
                    <td className="px-4 py-2 text-right">
                      <Button size="sm" variant="outline" data-testid={`restore-action-${a.id}`} onClick={() => restoreAction(a.id)}><ArrowCounterClockwise size={14} className="mr-1" />Restore</Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Layout>
  );
}
